import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoRetirementDocBloc from "../../blocs/retirement/info-perso/REInfoRetirementDocBloc";
import GeneralDataProtectionBloc from "../../blocs/common/GeneralDataProtectionBloc";


export default function REInfoRetirementDocPage() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Justificatifs de pension de retraite</h1>
       
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop bg-blanc p-lg shadow-noir">
            <REInfoRetirementDocBloc />
        </div>
        <div className="m-lg-desktop">
          <GeneralDataProtectionBloc/> 
        </div>

      </div>
   
    )

}